import { globalStore } from '@app/model/store'
import {
  setCategory,
  setInitState,
  setOpened,
  setPrefilledData,
  setPreselectedCategory,
} from '@widgets/Common/ModalFeedback/model/slice'
import { TypeFeedbackCategory } from '@widgets/Common/ModalFeedback/model/types'

export const openModal = (selectedCategory?: TypeFeedbackCategory) => (dispatch) => {
  const { user } = globalStore.getState().global

  user.data && dispatch(setPrefilledData({ full_name: user.data.username, email: user.data?.email || undefined }))
  if (selectedCategory) {
    dispatch(setPreselectedCategory(true))
    dispatch(setCategory(selectedCategory))
  }

  dispatch(setOpened(true))
}

export const closeModal = () => (dispatch) => {
  dispatch(setInitState())
}
